import * as React from "react";

function IconYoutube(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.487 10.776c2.133-.145 6.89-.146 9.025 0 2.312.158 2.582 1.559 2.599 5.224-.017 3.672-.29 5.067-2.599 5.224-2.135.146-6.892.145-9.025 0C9.175 21.066 8.906 19.665 8.89 16c.017-3.672.289-5.067 2.598-5.224zm2.735 2.557v5.334l5.333-2.672-5.333-2.662z"
        fill="#FF0200"
      />
    </svg>
  );
}

export default IconYoutube;
